<template>
  <el-dialog class="qr-code-dialog" width="290px" :visible.sync="dialogShow">
    <div class="dialog-header">{{ headerLabel }}</div>
    <el-divider></el-divider>
    <div v-rect-loading="loading" class="qr-code-container">
      <vue-qr
        v-show="!loading"
        :logoSrc="logo"
        :logoScale="qrLogoScale"
        :text="data"
        :size="qrSize"
        :callback="qrCallBack">
      </vue-qr>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        class="download-btn"
        type="primary"
        icon="el-icon-download"
        @click="handleDownloadQrCode"
      >
        {{ $t('common.btn.download') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import VueQr from 'vue-qr'
import { base64SrcToBlob } from '@/utils/common'

export default {
  components: {
    VueQr
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    headerLabel: {
      type: String,
      default: ''
    },
    qrImageName: {
      type: String,
      required: true
    },
    qrLogo: {
      type: String,
      required: true
    },
    qrLogoScale: {
      required: false,
      default: 0.2
    },
    qrData: {
      type: String,
      required: true
    },
    qrSize: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      logo: null,
      data: null,
      logoFormatter: null,
      qrImage: null
    }
  },
  computed: {
    logoWatcher () {
      return this.qrLogo
    },
    qrDataWatcher () {
      return this.qrData
    },
    dialogShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', false)
      }
    }
  },
  created () {
    this.formatQrLogo()
    this.refreshQrImage()
  },
  methods: {
    formatQrLogo () {
      if (this.logo === this.qrLogo) {
        return
      }
      this.logoFormatter = new Promise((resolve, reject) => {
        const logo = this.qrLogo
        const img = new Image()
        img.onload = () => {
          this.logo = logo
          resolve()
        }
        img.onerror = () => {
          this.logo = require('@/assets/image/jobDetail/blank-logo.png')
          resolve()
        }
        img.src = logo
      }).finally(() => {
        this.logoFormatter = null
      })
    },
    async refreshQrImage () {
      if (this.data === this.qrData) {
        return
      }
      this.loading = true
      if (this.logoFormatter) {
        await this.logoFormatter
      }
      this.data = this.qrData
    },
    qrCallBack (qrImage) {
      this.qrImage = qrImage
      this.loading = false
    },
    handleDownloadQrCode () {
      if (this.loading) {
        return
      }
      const blob = base64SrcToBlob(this.qrImage)
      const aEl = document.createElement('a')
      aEl.download = `${this.qrImageName}.png`
      aEl.href = URL.createObjectURL(blob)
      aEl.click()
    }
  },
  watch: {
    logoWatcher () {
      this.formatQrLogo()
    },
    qrDataWatcher () {
      this.refreshQrImage()
    }
  }
}
</script>

<style lang="scss" scoped>
.qr-code-dialog {
  ::v-deep {
    .el-dialog__header {
      padding: 0
    }

    .el-dialog__body {
      padding-bottom: 0;
    }
  }

  .dialog-header {
    font-size: 16px;
    font-weight: 500;
  }

  .qr-code-container {
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }

  .el-divider {
    margin: 10px 0;
  }

  .dialog-footer {
    .download-btn {
      display: block;
      margin: auto;
      font-size: 16px;
      border-radius: 2px;

      ::v-deep {
        span {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>
